import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";
import { IResourceDetails } from "../../types";
import PipelineBuilds from "../../components/PipelineBuilds";

const ResourcePipelineBuilds = () => {
    const { projectId, resourceName, envId } = useParams();
    const { resourceDetails } = useOutletContext<{ resourceDetails: IResourceDetails }>();
    const [pipelineId, setPipelineId] = useState<string>();

    useEffect(() => {
        setPipelineId(resourceDetails?.pipelineId)
    }, [resourceDetails])

    return (
        <PipelineBuilds
            buildPath={`/projects/${projectId}/environments/${envId}/resources/${resourceName}`}
            pipelineId={pipelineId!}
            projectId={projectId!}
        />
    )
}

export default ResourcePipelineBuilds;